import ContextProcessor from '../context/context-processor';
import { C11nEnv } from '../interpreter/c11n-env';
import { getLocaleUtils } from '../locale/locale-utils';
import { getParagraph } from '../rules/rules-store';

import { resolveParagraphContent } from './parser';

class ParagraphUtils {
  static getParagraphStream(paragraphRuleObj: string, c11nEnv: C11nEnv, category?: string) {
    return resolveParagraphContent(paragraphRuleObj, c11nEnv, category);
  }

  static isDecisionParagraph(paragraphName: string, classID: string) {
    const paragraph = getParagraph(paragraphName, classID);
    return !!paragraph?.useDecision;
  }

  static processParagraph(paragraphName: string, c11nEnv: C11nEnv) {
    const classID = c11nEnv.getCurrentClassID();
    const paragraph = getParagraph(paragraphName, classID);
    let decidedParagraph;

    if (paragraph?.useDecision) {
      const len = paragraph.dynamicContents.length;
      for (let i = 0; i < len - 1; i += 1) {
        if (ContextProcessor.resolveWhen(paragraph.dynamicContents[i].when, c11nEnv)) {
          decidedParagraph = paragraph.dynamicContents[i];
          paragraphName = `${paragraphName}#${decidedParagraph.when}`;
          break;
        }
      }
      if (!decidedParagraph) {
        decidedParagraph = paragraph.dynamicContents.pop();
      }
    } else {
      decidedParagraph = paragraph;
    }

    const definedOnClass = paragraph?.definedOnClassID;
    const paragraphContent = getLocaleUtils().getParagraphLocaleValue(definedOnClass || classID, paragraphName);

    if (paragraphContent) {
      return ParagraphUtils.getParagraphStream(paragraphContent.content, c11nEnv, paragraphContent?.category);
    }
    if (decidedParagraph?.content) {
      return ParagraphUtils.getParagraphStream(decidedParagraph.content, c11nEnv, decidedParagraph?.category);
    }
    return null;
  }
}

export default ParagraphUtils;
